import React from "react";
import { Flex } from "@chakra-ui/react";
import { FaCar } from "react-icons/fa";
import { FiSearch, FiUserCheck, } from "react-icons/fi";
import { ROUTES } from "constants/routes-path";
import CardList from "components/Card/CardList";

function QueriesList() {
    const queriesConfig = [
        {
            icon: FaCar,
            route: `${ROUTES.panel}${ROUTES.transportManagement}${ROUTES.searches}${ROUTES.searchVehicle}`,
            titleKey: "queries.title.query-vehicles",
            descriptionKey: "queries.description.query-vehicles",
        },
        {
            icon: FiUserCheck,
            route: `${ROUTES.panel}${ROUTES.transportManagement}${ROUTES.searches}${ROUTES.searchDrivers}`,
            titleKey: "queries.title.query-drivers",
            descriptionKey: "queries.description.query-drivers",
        },
        {
            icon: FiSearch,
            route: `${ROUTES.panel}${ROUTES.transportManagement}${ROUTES.searches}${ROUTES.searchSenatran}`,
            titleKey: "queries.title.query-senatran",
            descriptionKey: "queries.description.query-senatran",
        },
    ];

    return (
        <Flex
            gap="5"
            direction="column"
            pt={{ base: "180px", sm: "155px", lg: "90px" }}
            px="30px"
        >
            <CardList items={queriesConfig} />
        </Flex>
    );
}

export default QueriesList;